import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
import hy from '@/locales/hy.json'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

var locale = window.location.pathname.split("/")[1]

if(!['hy', 'en', 'ru'].includes(locale)){
  locale = DEFAULT_LANGUAGE
}

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: locale, // set locale
  sync: false,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: {
    hy: hy,
    en: en,
    ru: ru
  } // set locale messages
})
